export class DeletePageAction {
  public static readonly type = '[Project/Wiki/List] DeletePageAction';
  constructor(public readonly id: string) {}
}
